import { useEffect, useMemo, useState } from 'react';
import { postAutocomplete, SearchFilterType, } from '@zurich/api/search';
import { useApiQuery, useDebounce } from '@zurich/common/hooks';
import { createSearchFilter } from '../utils';
export function useSearchAutocomplete({ index, enabled, filters = {}, searchOptions, }) {
    const [filter, setFilter] = useState();
    const debouncedFilter = useDebounce(filter, 300);
    const { data, dataState } = useApiQuery({
        request: postAutocomplete,
        params: {
            body: {
                index,
                filters: {
                    searchFilterEntries: debouncedFilter
                        ? Object.entries(debouncedFilter).reduce((filters, [field, value]) => typeof value === 'string' && value
                            ? [
                                ...filters,
                                createSearchFilter(field, [value], SearchFilterType.PHRASE),
                            ]
                            : typeof value === 'boolean'
                                ? [
                                    ...filters,
                                    createSearchFilter(field, [String(value)], SearchFilterType.PHRASE),
                                ]
                                : filters, [])
                        : [],
                    options: searchOptions,
                },
            },
        },
        options: {
            errorText: 'Fehler beim Laden der Daten in der Auswahlliste',
        },
        queryOptions: { enabled },
    });
    useEffect(() => {
        if (JSON.stringify(filters) !== JSON.stringify(filter)) {
            setFilter(filters);
        }
    }, [filter, filters]);
    // don't recreate empty object everytime to avoid re-render loop
    const options = useMemo(() => data ?? [], [data]);
    return [options, { loading: dataState === 'loading' }];
}
